import Vue from "vue"
import VueRouter from "vue-router"

Vue.use(VueRouter)

const routes = [
  { path: "/", redirect: "/home" },
  {
    path: "/login",
    name: "Login",
    component: () => import("@/views/login/index.vue"),
    meta: { title: "登录 - 百万同城" }
  },
  {
    path: "/home",
    name: "Home",
    component: () => import("@/views/home/index.vue"),
    meta: { title: "百万同城" }
  },
  {
    path: "/search",
    name: "Search",
    component: () => import("@/views/search/index.vue"),
    meta: { title: "搜索 - 百万同城" }
  },
  {
    path: "/detail/:id",
    name: "Detail",
    component: () => import("@/views/detail/index.vue"),
    meta: { title: "详情 - 百万同城" }
  },
  {
    path: "/category",
    name: "Category",
    component: () => import("@/views/category/index.vue"),
    meta: { title: "信息列表 - 百万同城" }
  },
  {
    path: "/more",
    name: "More",
    component: () => import("@/views/more/index.vue"),
    meta: { title: "更多栏目 - 百万同城" }
  },
  {
    path: "/phonebook",
    name: "Phonebook",
    component: () => import("@/views/phonebook/index.vue"),
    meta: { title: "电话本 - 百万同城" }
  },
  {
    path: "/phonebook/:id",
    name: "PhoneDetail",
    component: () => import("@/views/phonebook/detail.vue"),
    meta: { title: "电话本详情 - 百万同城" }
  },
  {
    path: "/redpacket",
    name: "Redpacket",
    component: () => import("@/views/redpacket/index.vue"),
    meta: { title: "领红包 - 百万同城" }
  },
  {
    path: "/wechat-group",
    name: "WechatGroup",
    component: () => import("@/views/wechat-group/index.vue"),
    meta: { title: "微信群 - 百万同城" }
  },
  {
    path: "/news",
    name: "News",
    component: () => import("@/views/news/index.vue"),
    meta: { title: "新闻资讯 - 百万同城" }
  },
  {
    path: "/news/:id",
    name: "NewsDetail",
    component: () => import("@/views/news/detail.vue"),
    meta: { title: "新闻详情 - 百万同城" }
  },
  {
    path: "/enterprise",
    name: "Enterprise",
    component: () => import("@/views/enterprise/index.vue"),
    meta: { title: "名企推荐 - 百万同城" }
  },
  {
    path: "/company/:userId",
    name: "Company",
    component: () => import("@/views/company/index.vue"),
    meta: { title: "公司详情 - 百万同城" }
  },
  {
    path: "/user/:userId",
    name: "UserProfile",
    component: () => import("@/views/user/index.vue"),
    meta: { title: "用户详情 - 百万同城" }
  },
  {
    path: "/help",
    name: "Help",
    component: () => import("@/views/help/index.vue"),
    meta: { title: "帮助 - 百万同城" }
  },
  {
    path: "/help/detail",
    name: "HelpDetail",
    component: () => import("@/views/help/detail.vue"),
    meta: { title: "问题详情 - 百万同城" }
  },
  {
    path: "/complaint",
    name: "Complaint",
    component: () => import("@/views/complaint/index.vue"),
    meta: { title: "投诉 - 百万同城" }
  },
  {
    path: "/estate/agencies",
    name: "EstateAgencies",
    component: () => import("@/views/estate/agencies.vue"),
    meta: { title: "房产中介 - 百万同城" }
  },
  {
    path: "/estate/properties",
    name: "EstateProperties",
    component: () => import("@/views/estate/properties.vue"),
    meta: { title: "楼盘新房 - 百万同城" }
  },
  {
    path: "/market",
    name: "Market",
    component: () => import("@/views/market/index.vue"),
    meta: { title: "市场分布 - 百万同城" }
  },
  {
    path: "/market/:id",
    name: "MarketDetail",
    component: () => import("@/views/market/detail.vue"),
    meta: { title: "市场分布 - 百万同城" }
  }
]

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
  scrollBehavior() {
    return { x: 0, y: 0 }
  }
})

router.beforeEach((to, from, next) => {
  document.title = to.meta.title || "百万同城"
  next()
})

export default router
